import React, { useEffect, useState } from "react";
import svg17 from "../../../../../../assets/svg/svg17.svg";
import { Descriptions, Table } from "antd";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import IwuaAdd from "../../IwuaAdd";
import useModalToggle from "../../../../../../custom_hooks/useModalToggle";
import moment from "moment";
import { formatPath, previewPaper } from "../../../../../../utils";

function Information() {
  const urlLicense = "sch/get_institution_licences";
  const { iwuaLicenseData } = useSelector((state) => ({
    iwuaLicenseData: state.fetch.data[urlLicense] || [],
  }));
  const { iwuaPrivateObj } = useSelector((state) => state.obj);
  const { activeObjSchemes } = useSelector((state) => ({
    activeObjSchemes: state.obj.activeObj["privateSchemes"],
  })); 
 
  const navigate = useNavigate();
  const { open, handleCancel, handleOpen } = useModalToggle();
  const items1 = [
    {
      key: "1",
      label: "Scheme Name",
      children: activeObjSchemes?.schName ?? "N/A",
    },
    {
      key: "7",
      label: "Iwua Name",
      children: iwuaPrivateObj?.instName ?? "N/A",
    },
    {
      key: "2",
      label: "Date Registered",
      children: (
        <div>
          {iwuaPrivateObj?.instRegCertDate
            ? moment(iwuaPrivateObj?.instRegCertDate)?.format("DD-MM-YYYY")
            : "--"}
        </div>
      ),
    },
    {
      key: "12",
      label: "Physical Location",
      children: iwuaPrivateObj?.instLocation ?? "N/A",
    },
    {
      key: "6",
      label: "Major Crop",
      children: iwuaPrivateObj?.instCrops ?? "N/A",
    },
    {
      key: "3",
      label: "Status",
      children: iwuaPrivateObj?.instStatus ?? "N/A",
    },

    {
      key: "8",
      label: "Number of Farmers",
      children: iwuaPrivateObj?.instNoOfMembers ?? "N/A",
    },
    {
      key: "9",
      label: "Irrigation Type",
      children: activeObjSchemes?.schIrrigationType ?? "N/A",
    },
    {
      key: "10",
      label: "Source of Water",
      children: activeObjSchemes?.schWaterSource ?? "N/A",
    },
  ];
  const items2 = [
    {
      key: "1",
      label: "Name",
      children: iwuaPrivateObj?.instContName ?? "N/A",
    },
    {
      key: "2",
      label: "ID Number",
      children: iwuaPrivateObj?.instContIdNumber ?? "N/A",
    },
    {
      key: "3",
      label: "Email",
      children: iwuaPrivateObj?.instContEmail ?? "N/A",
    },

    {
      key: "4",
      label: "Active Phone",
      children: iwuaPrivateObj?.instContPhone ?? "N/A",
    },
  ];

  const handleEdit = async () => {
    await handleOpen();
  };

  async function fetchMyUsersData() {}
  useEffect(() => {
    fetchMyUsersData();
  }, []);
  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (_, __, index) => index + 1,
    },
    {
      title: "License Type",
      dataIndex: "licType",
      sorter: (a, b) => a.projectName.localeCompare(b.projectName),
    },
    {
      title: "File",
      dataIndex: "lcPath",
      render: (item) => {
        return (
          <div
            onClick={() => previewPaper(item)}
            className="cursor-pointer text-darkBlue"
          >
            {formatPath(item)}
          </div>
        );
      },
    },
  ];
  const [column, setColumn] = useState(2);
  const [labelStyle, setLabelStyle] = useState(180);
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width < 640) {
        setColumn(1);
        setLabelStyle(150);
      } else if (width < 1024) {
        setColumn(2);
        setLabelStyle(250);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div className="px-[1.25rem] ">
      <div className="flex items-center justify-between">
        <div className="form-add-h">About</div>
      </div>
      <div className="custom-title mt-[2.25rem]">Iwua Details</div>
      <Descriptions
        column={column}
        colon={true}
        items={items1}
        labelStyle={{ width: labelStyle }}
      />

      <div className="custom-title mt-[2.5rem]">Contact Person</div>
      <Descriptions
        column={2}
        colon={true}
        items={items2}
        labelStyle={{ width: labelStyle }}
      />
      <IwuaAdd
        isModalOpen={open}
        handleCancel={handleCancel}
        handleFetch={fetchMyUsersData}
        prodd={iwuaPrivateObj}
      />

     
      <Table
        rowSelection={false}
        className="mt-[2.5rem] w-full"
        scroll={{
          x: "auto",
        }}
        rowKey={(record) => record?.licId}
        columns={columns}
        dataSource={iwuaLicenseData}
      />
    </div>
  );
}

export default Information;
